export const classNames = (classes: Record<string, boolean | undefined | null>): string => {
  return Object.entries(classes)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(" ")
}

export const twClassNames = (...classes: (string | boolean | undefined | null)[]): string => {
  return classes.filter(Boolean).join(" ")
}
